export default __webpack_public_path__ + "static/media/timer2.57ca6c4f.jpg";